// extracted by mini-css-extract-plugin
module.exports = {"Footer":"index-module--Footer--3cXKE","Left":"index-module--Left--1aZlK","Right":"index-module--Right--W3tWv"};